// export const BASE_URL = 'https://salesinfo.azurewebsites.net/api';
// export const BACKEND_URL = 'https://salesinfo.azurewebsites.net/shops';
// export const BASE_URL = 'https://test.sales-info.ch/api';
// export const BACKEND_URL = 'https://test.sales-info.ch/shops';
export const BASE_URL = 'https://sales-info.it/api';
export const BACKEND_URL = 'https://sales-info.it/shops';

export const IMAGE_BASE_URL = 'https://sales-info.it';


// export const BACKEND_URL = 'https://si.beriflapp.com';
// export const BASE_URL = 'https://si.beriflapp.com/api';

// export const BACKEND_URL = 'http://localhost:49243/';
// export const BASE_URL = 'http://localhost:49243/api/';



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/app.constants.ts